
const scaledWidthHeight = (imgWidth: number, imgHeight: number, size: number) => {
    const aspectRatio = imgWidth / imgHeight;
    let scaledWidth = 0;
    let scaledHeight = 0;
    if (imgWidth >= imgHeight) {
      scaledHeight = size / aspectRatio;
      scaledWidth = size;
    } else {
      scaledWidth = size * aspectRatio;
      scaledHeight = size;
    }
    return {
      scaledWidth: Math.round(scaledWidth),
      scaledHeight: Math.round(scaledHeight),
    };
}

export default scaledWidthHeight;